const BASE_CONFIG = require('./base.json')

class AppConfig {
  detectEnv() {
    this.currentHost = window.location.hostname
    if (this.currentHost === '142.93.23.176') {
      return 'prod'
    } else if (this.currentHost === 'transitpanama.com') {
      return 'live'
    }
    return 'local'
  }

  getConfig(env) {
    this.config = {}
    /* eslint-disable global-require */
    if (env === 'prod') {
      this.config = require('./prod.json')
    } else if (env === 'live') {
      this.config = require('./live.json')
    } else {
      this.config = require('./local.json')
    }
    /* eslint-enable global-require */
    return { ...BASE_CONFIG, ...this.config }
  }

  load() {
    const env = this.detectEnv()
    const config = this.getConfig(env)
    return config
  }
}

export default new AppConfig()
